import { EmployeeCheckListResponseDto } from './employee-check-list-response-dto.model';
import { ApiErrorCode } from '../service-proxies';


export class EmployeeCheckListResponseDtoApiResponse implements IEmployeeCheckListResponseDtoApiResponse {
    isSuccess!: boolean;
    responseData!: EmployeeCheckListResponseDto;
    errorCode!: ApiErrorCode;
    errorMessage!: string | undefined;
    errorTitle!: string | undefined;

    constructor(data?: IEmployeeCheckListResponseDtoApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.responseData = _data["responseData"] ? EmployeeCheckListResponseDto.fromJS(_data["responseData"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorTitle = _data["errorTitle"];
        }
    }

    static fromJS(data: any): EmployeeCheckListResponseDtoApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCheckListResponseDtoApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorTitle"] = this.errorTitle;
        return data; 
    }
}

export interface IEmployeeCheckListResponseDtoApiResponse {
    isSuccess: boolean;
    responseData: EmployeeCheckListResponseDto;
    errorCode: ApiErrorCode;
    errorMessage: string | undefined;
    errorTitle: string | undefined;
}

